export default "__VITE_ASSET__CTcOg45r__"